import { useRef } from 'react';

/**
 * Fire `fire()` synchronously during render the first time `condition` is
 * true within a mount. Re-mounts (e.g. Strict-Mode mount/unmount/remount in
 * dev) reset the flag and fire again, so `fire()` must be idempotent
 * (typically via a singleflight or downstream cache).
 */
export const useFireOnceOnRender = (condition: boolean, fire: () => void): void => {
	const firedRef = useRef(false);
	if (condition && !firedRef.current) {
		firedRef.current = true;
		fire();
	}
};
